import { render } from "./CreateWalletModal.vue?vue&type=template&id=4a88d8d8&scoped=true"
import script from "./CreateWalletModal.vue?vue&type=script&lang=js"
export * from "./CreateWalletModal.vue?vue&type=script&lang=js"

import "./CreateWalletModal.vue?vue&type=style&index=0&id=4a88d8d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a88d8d8"]])

export default __exports__